<template>
  <div>
    <Tooltip
      v-if="content"
      :position="position"
      theme="light"
      :canHover="canCopy"
    >
      <slot></slot>
      <div>{{ text }}</div>
      <template slot="content">
        <div v-if="isShowContent">{{ content }}</div>
        <div v-else>{{ text }}</div>
        <a v-if="canCopy" @click="copy()">复制</a>
      </template>
    </Tooltip>
  </div>
</template>
<script>
import Tooltip from 'kpc/components/tooltip';
import { copyToClip } from '@/services/utils';
export default {
  name: 'TableTooltip',
  components: {
    Tooltip
  },
  computed: {
    text() {
      return this.content.slice(0, this.contentLength);
    },
    position() {
      try {
        return JSON.parse(this.tipPosition);
      } catch {
        return this.tipPosition;
      }
    },
    isShowContent() {
      return !this.$slots.default;
    }
  },
  props: {
    content: {
      type: String
    },
    contentLength: {
      type: Number,
      default: 10
    },
    canCopy: {
      type: Boolean,
      default: false
    },
    tipPosition: {
      // type: String,
      default: 'right'
    }
  },
  methods: {
    copy() {
      try {
        copyToClip(this.content);
        this.Message['success']('复制成功');
      } catch (error) {
        this.Message['error']('复制失败');
      }
    }
  }
};
</script>
